import React, { useContext, useEffect, useRef, useState } from 'react';
import { WelletContext } from '../../context/WelletContext';
import { CircleSpinner } from 'react-spinners-kit';
import { useDispatch, useSelector } from 'react-redux';
import { getQueryString } from '../../helpers/url';
import {
  skeletonEmptyPerformances,
  skeletonSchedule,
} from '../../components/Skeletons/SkeletonRestaurantReservation';
import { generateDisabledDates, getDateFromOffset, getLocale } from '../../helpers/dates';
import { useHistory, useParams } from 'react-router-dom';
import { convertTime12to24 } from '../../helpers/dates';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { setReservation } from '../../actions/reservationActions';
import Header from '../../components/Common/Header/Header';
import ReservationSelector from '../../components/ReservationSelector/ReservationSelector';
import ContentApp from '../../components/ContentApp';
import ProductPerformanceSelector from '../../components/ProductPerformanceSelector/ProductPerformanceSelector';
import EmptyActivity from '../../components/Common/EmptyActivity/EmptyActivity';
import Calendar from '../../components/Common/Calendar/Calendar';
import Button from '../../components/Common/Button/Button';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import ProductModal from '../../components/Common/ProductModal/ProductModal';
import '../../css/product-list.css';
import styles from './reservation.module.css';
import SeatsAvailableOpenTable from '../../components/Common/SeatsAvailableOpenTable/SeatsAvailableOpenTable';
import { lockSchedule } from '../../services/reservations/reservationsService';
import { setAvailableTime } from '../../actions/timerActions';
import axios from 'axios';
const Reservation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const history = useHistory();
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const showId = getQueryString('showId');
  const rawPlatform = getQueryString('platform');
  const platform = rawPlatform === 'true' ? true : rawPlatform === 'false' ? false : rawPlatform;
  const calendarRef = useRef(null);
  const canBook = useSelector((state) => state.associates.roles).includes('associate');
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(true);
  const [externalPlaftorm, setExternalPlaftorm] = useState();
  const [today, setToday] = useState(null);
  const [compareToday, setCompareToday] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [disabledDates, setDisabledDates] = useState([]);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const seatInfoReservation = useSelector((state) => state?.reservation?.attribute);
  const [selectedSeatType, setSelectedSeatType] = useState(seatInfoReservation || null);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [intervals, setIntervals] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [hasCallCenter, setHasCallCenter] = useState(null);
  const { reservationType } = useParams();
  const reservationTypeRestaurant = 'RESTAURANT';
  const [scheduleNotAvailable, setScheduleNotAvailable] = useState(false);
  const reservationInfoPaxs = useSelector((state) => state?.reservation?.paxs);
  const reservationInfoDate = useSelector((state) => state?.reservation?.date);
  const reservationInfoPerformance = useSelector((state) => state?.reservation?.performance);
  const CancelToken = axios.CancelToken;
  let cancelSchedulePrevious;
  const [selectedPerformance, setSelectedPerformance] = useState(
    reservationInfoPerformance || null,
  );
  const [selectedPax, setSelectedPax] = useState(reservationInfoPaxs || 2);
  const [useExternalPlatform, setUseExternalPlatform] = useState(true);

  useEffect(() => {
    setSelectedPerformance(null);
  }, [selectedSeatType]);
  useEffect(() => {
    if (seatInfoReservation) {
      setSelectedSeatType(seatInfoReservation);
    }
  }, [seatInfoReservation]);
  const safeLocalDate = (dateStr) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const [selectedDate, setSelectedDate] = useState(
    reservationInfoDate ? safeLocalDate(reservationInfoDate) : null,
  );
  useEffect(() => {
    setSelectedPerformance(null);
  }, [selectedSeatType]);
  useEffect(() => {
    if (reservationInfoPerformance && intervals.length > 0) {
      const matchedPerformance = intervals.find(
        (interval) => format(interval.time, 'HH:mm') === reservationInfoPerformance,
      );
      if (matchedPerformance) {
        setSelectedPerformance(format(matchedPerformance.time, 'HH:mm'));
      }
    }
  }, [intervals, reservationInfoPerformance]);
  useEffect(() => {
    if (seatInfoReservation && seatInfoReservation !== selectedSeatType) {
      setSelectedSeatType(seatInfoReservation);
    }
  }, [seatInfoReservation]);
  const handleSeatChange = (seatValue) => {
    setSelectedSeatType(seatValue);
  };
  const getExternalPlatform = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/${showId}/external-plaftorm/config?reservationType=RESTAURANT`,
      );
      setExternalPlaftorm(result.data);
    } catch (error) {
      console.error(error);
    }
  };
  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: language,
          reservationType: 'RESTAURANT',
        },
      });
      setShow(result.data);
      let todayDate = new Date();
      if (result.data.calendar) todayDate = new Date(result.data.calendar.minDate);
      else todayDate = new Date(getDateFromOffset(result.data.utcOffset));
      const yesterdayDate = new Date(todayDate);
      yesterdayDate.setDate(yesterdayDate.getDate() - 1);
      const firstDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
      setToday(todayDate);
      setCompareToday(todayDate);
      setMinDate(new Date(todayDate.getFullYear(), todayDate.getMonth(), 0 + 1));
      setDisabledDates(generateDisabledDates(firstDate, yesterdayDate, locale));

      if (!selectedDate) {
        setSelectedDate(todayDate);
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  const getSchedule = async (date, reservationType) => {
    const formatedDate = format(date, 'yyyy-MM-dd');
    setIntervals([]);
    setLoadingSchedule(true);
    if (cancelSchedulePrevious && typeof cancelSchedulePrevious === 'function') {
      cancelSchedulePrevious('Cancel previous schedule request');
    }

    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/GetSchedule?showId=${showId}&date=${formatedDate}&reservationType=${reservationType}&paxs=${selectedPax}`,
        {
          cancelToken: new CancelToken(function executor(c) {
            cancelSchedulePrevious = c;
          }),
        },
      );

      if (result.data?.scheduleFromExternalPlatform === false) {
        setUseExternalPlatform(false);
      } else {
        setUseExternalPlatform(true);
      }

      const rawSchedules = result.data?.schedules || [];
      if (rawSchedules.length === 0) {
        setIntervals([]);
        setLoadingSchedule(false);
        return;
      }

      const formattedTimes = rawSchedules.map((time) => {
        const time24 = new Date(
          format(date, 'yyyy-MM-dd') + 'T' + convertTime12to24(time.timeStart),
        );
        if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
          time24.setDate(time24.getDate() + 1);

        return {
          time24,
          soldOut: time.isSoldOut,
          attributes: time.attributes || [],
          originalData: time,
        };
      });
      formattedTimes.sort();
      const allIntervals = formattedTimes.map(({ time24, soldOut, attributes, originalData }) => ({
        time: time24,
        soldOut,
        attributes,
        originalData,
      }));
      setIntervals(allIntervals);
      setLoadingSchedule(false);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error.message);
        return;
      }
      console.error(error);
      setLoadingSchedule(false);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedPax && showId) {
      getSchedule(selectedDate, reservationTypeRestaurant);
    }
    return () => {
      if (cancelSchedulePrevious && typeof cancelSchedulePrevious === 'function') {
        cancelSchedulePrevious('Cleanup on dependency change');
      }
    };
  }, [selectedDate, selectedPax, showId]);
  useEffect(() => {
    if (seatInfoReservation) {
      setSelectedSeatType(seatInfoReservation);
    }
  }, []);

  useEffect(() => {
    if (show && show.reservationTypes && Array.isArray(show.reservationTypes)) {
      const reservation = show.reservationTypes.find(
        (item) => item.type.toLowerCase() === reservationTypeRestaurant.toLowerCase(),
      );
      if (reservation) {
        const hasCallCenter = reservation.hasCallCenter;
        setHasCallCenter(hasCallCenter);
      }
    }
  }, [show]);
  const getFilteredAndFormattedIntervals = () => {
    const filteredIntervals =
      selectedSeatType && selectedSeatType.length > 0
        ? intervals.filter((interval) => interval.attributes?.includes(selectedSeatType))
        : intervals;

    return filteredIntervals.map((interval) => ({
      ...interval,
      time: interval.time,
      soldOut: interval.soldOut,
    }));
  };

  useEffect(() => {
    if (useExternalPlatform) {
      getExternalPlatform();
    }
    getShow();
  }, []);
  useEffect(() => {
    if (today !== null) getSchedule(today, 'RESTAURANT');
  }, [today]);
  const enableSelect = () => {
    setSelectDisabled(false);
  };

  const handleChangeDate = async (day) => {
    setSelectedPerformance(null);
    if (day !== undefined) {
      setSelectedDate(day);
      getSchedule(day, 'RESTAURANT');
    }
    setCalendarVisible(!calendarVisible);
  };

  const onSelectPerformance = (performance) => {
    setSelectedPerformance(performance);
    setScheduleNotAvailable(false);
  };
  const handleContinue = async () => {

    const restaurantHasExternalPlatform = show.reservationTypes?.find(
      (type) => type.type === 'RESTAURANT' && type.hasExternalPlatform,
    );
    const reservationHasCallCenter = hasCallCenter || (!hasCallCenter && !useExternalPlatform && restaurantHasExternalPlatform);
    const reservationInfo = {
      showId: showId,
      showName: show.name,
      products: null,
      performance: selectedPerformance,
      date: format(selectedDate, 'yyyy-MM-dd'),
      paxs: selectedPax,
      callCenter: reservationHasCallCenter,
      attribute: selectedSeatType,
    };

    dispatch(setReservation(reservationInfo));

    if (canBook) {
      if (useExternalPlatform) {
        const restaurantReservation = show.reservationTypes?.find(
          (type) => type.type === 'RESTAURANT' && type.hasExternalPlatform,
        );

        if (restaurantReservation) {
          try {
            const result = await lockSchedule(welletContext, {
              pax: selectedPax,
              reservationDateLocalTime:
                format(selectedDate, 'yyyy-MM-dd') + 'T' + selectedPerformance,
              reservationType: 'RESTAURANT',
              showId: showId,
              attribute: selectedSeatType,
            });

            if (result?.success === false) {
              setScheduleNotAvailable(true);
              return;
            }

            dispatch(setAvailableTime(result?.expiresAt));
            if (result?.reservation_Token) {
              history.push({
                pathname: '/reservation-check',
                search: `?show=${show.name}&showId=${showId}&platform=${useExternalPlatform}&reservationToken=${result.reservation_Token}&seats=${selectedSeatType}`,
              });
              return;
            }
          } catch (error) {
            console.error('Error locking schedule:', error);
            setErrorMessage(t('reservationError.GENERIC_ERROR'));
            return;
          }
        }
      }

      history.push({
        pathname: '/reservation-check',
        search: `?show=${show.name}&showId=${showId}&platform=${useExternalPlatform}`,
      });
    } else {
      setErrorMessage(t('cantBook'));
    }
  };
  return loading ? (
    <div className='loaderDiv'>
      <CircleSpinner
        className='spinner-app mx-auto'
        style={{ margin: 'auto' }}
        size={40}
        color='var(--color-font-primary)'
      />
    </div>
  ) : (
    <>
      <ProductModal
        open={calendarVisible}
        fullScreen
        animationClass='fade-up-horizontal'
        hasBackground
        showCloseButton={false}
      >
        <Header onClick={() => setCalendarVisible(false)} showBack />
        <ContentApp>
          <Calendar
            disabledDates={disabledDates}
            minDate={minDate}
            onSelectDate={handleChangeDate}
            selectedDate={selectedDate}
          />
        </ContentApp>
      </ProductModal>
      <Header title={<div className='text-capitalize px-3'>{t('book') + ' ' + show.name}</div>} />
      <ContentApp menu={true}>
        {!loading && compareToday !== null && selectedDate !== null ? (
          <>
            <div className='mt-4 '>
              <ReservationSelector
                selectedPax={selectedPax}
                setSelectedPax={setSelectedPax}
                selectedDate={selectedDate}
                selectDisabled={selectDisabled}
                enableSelect={enableSelect}
                handleChangeDate={handleChangeDate}
                loading={loadingSchedule}
                setCalendarVisible={setCalendarVisible}
                calendarVisible={calendarVisible}
                setSelectDisabled={setSelectDisabled}
                calendarRef={calendarRef}
                initialSlide={0}
              />
            </div>
            {useExternalPlatform && externalPlaftorm?.showPowerBy && (
              <SeatsAvailableOpenTable
                selectedSeatType={seatInfoReservation}
                intervals={intervals}
                onSeatChange={handleSeatChange}
              />
            )}

            <div className={`mt-2 ${scheduleNotAvailable && styles.bottomSchedules}`}>
              {!loadingSchedule ? (
                <>
                  {intervals?.length > 0 && !loadingSchedule ? (
                    <div className='fade-up'>
                      <div className='mt-3 mb-1 text-secondary bold'>{t('selectTime')}</div>
                      <div className='mt-3'>
                        <ProductPerformanceSelector
                          performances={
                            externalPlaftorm?.showPowerBy
                              ? getFilteredAndFormattedIntervals()
                              : intervals
                          }
                          onSelect={onSelectPerformance}
                          selectedPerformance={selectedPerformance}
                          language={language}
                          selectedDate={selectedDate}
                          loadingSchedule={loadingSchedule}
                          today={compareToday}
                        />
                      </div>
                    </div>
                  ) : !loadingSchedule ? (
                    <EmptyActivity icon={'notification'} title={'No hay horarios disponibles'} />
                  ) : (
                    skeletonSchedule()
                  )}
                </>
              ) : (
                <>{skeletonEmptyPerformances()}</>
              )}
            </div>
            <div
              className='position-fixed w-100'
              style={{
                bottom: 0,
                left: 0,
                backgroundColor: '#000',
                paddingBottom: 'env(safe-area-inset-bottom)',
              }}
            >
              <div className='container'>
                <div className='row justify-content-center mt-2'>
                  <div className='col-12 col-md-7 col-lg-6'>
                    {errorMessage && <ErrorBox title={errorMessage} />}
                    <Button
                      text={t('continue')}
                      size='large'
                      className={`mt-2 mb-2 `}
                      onClick={handleContinue}
                      icon={true}
                      typeIcon='arrow'
                      iconColor='#000'
                      disabled={!selectedPax || !selectedPerformance}
                    />

                    {scheduleNotAvailable && (
                      <div className=' mb-2'>
                        <ErrorBox title={t('scheduleIsNotAvailable')}> </ErrorBox>
                      </div>
                    )}
                  </div>
                </div>
                {useExternalPlatform && externalPlaftorm?.showPowerBy && (
                  <div className='row justify-content-center'>
                    <div className={styles.poweredByContainer}>
                      <span className='semi_bold mr-1 font-smaller'>Powered by&nbsp;</span>
                      {externalPlaftorm && (
                        <img
                          className={styles.containerImgLogoPlatform}
                          src={externalPlaftorm?.logoUrl}
                          alt='logo-restaurant'
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : null}
      </ContentApp>
    </>
  );
};
export default Reservation;
